import * as React from 'react';
import { useState, useEffect } from 'react';
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, MenuItem, Avatar, IconButton, Popover, Link } from '@mui/material';
import { useMsal } from '@azure/msal-react';

export default function AccountPopover() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    getUserAndTokenInfo();
  }, []);

  const getUserAndTokenInfo = () => {
    let initials;
    try {
      const namesList = activeAccount.idTokenClaims.name.split(" ");
      initials = namesList[0][0] + namesList[1][0];
    } catch (err) {
      initials = 'US';
    }
    const userInfoVar = {
      name: activeAccount.idTokenClaims.name,
      email: activeAccount.idTokenClaims.preferred_username,
      initials,
    };
    setUserInfo(userInfoVar);
  };

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    instance.logoutRedirect({
      onRedirectNavigate: () => false,
    });
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar sx={{ bgcolor: 'secondary.main' }}>{userInfo.initials}</Avatar>
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {userInfo.name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {userInfo.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleClose} sx={{ m: 1 }}>
          <Link color="inherit" onClick={handleLogout} underline="none">
            Logout
          </Link>
        </MenuItem>
      </Popover>
    </>
  );
}
